<div class="page-header-container">
  <ng-content></ng-content>
</div>
